import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent implements OnInit {
  @Input() heading: string;
  @Input() color: string;
  @Output() e = new EventEmitter();
  constructor() { }
  public defaultColors: string[] = [
    '#F44336',
    '#B71C1C',
    '#D50000',
    '#E91E63',
    '#880E4F',
    '#9C27B0',
    '#4A148C',
    '#3F51B5',
    '#304FFE',
    '#90CAF9',
    '#00B0FF',
    '#004D40',
    '#4CAF50',
    '#00C853',
    '#33691E',
    '#76FF03',
    '#FFEB3B',
    '#F57F17',
    '#FF9800',
    '#FF5722',
    '#BF360C',
    '#795548',
    '#3E2723',
    '#9E9E9E',
    '#424242',
    '#000000'

  ];
  public show = false;
  ngOnInit(): void {
  }
   /**
 * Change status of visibility to color picker
 */
public toggleColors() {
  this.show = !this.show;
}
/**
 * Change color from default colors
 * @param {string} color
 */
public changeColor(color: string) {
  this.color = color;
  this.e.emit(this.color); // Return color
  
  this.show = false;
}
/**
 * Change color from input
 * @param {string} color
 */
public changeColorManual(color: string) {
  const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

  if (isValid) {
    this.color = color;
    this.e.emit(this.color); // Return color
  }
}

}
